const STORAGE_KEY = 'revisr_active_workspace';

export const getActiveWorkspaceId = (): string | null => {
  return localStorage.getItem(STORAGE_KEY);
};
